import {CourseDefinitionContentTypeEnum} from 'src/api/ProactApiClient';

/**
 * Content type labels and ordering, shared by the outline's "Add Content"
 * menu and the editor's "Change type" menu. Kept out of `ContentEditorPanel`
 * so the outline does not pull the editor's media/upload dependencies into
 * its module graph.
 */
export const contentTypes: CourseDefinitionContentTypeEnum[] = [
  CourseDefinitionContentTypeEnum.Lesson,
  CourseDefinitionContentTypeEnum.Quiz,
  CourseDefinitionContentTypeEnum.Demonstration,
];

export const contentTypeLabel = (
  type?: CourseDefinitionContentTypeEnum
): string => {
  switch (type) {
    case CourseDefinitionContentTypeEnum.Lesson:
      return 'Lesson';
    case CourseDefinitionContentTypeEnum.Quiz:
      return 'Quiz';
    case CourseDefinitionContentTypeEnum.Demonstration:
      return 'Demonstration';
    default:
      return 'Invalid';
  }
};
